import { defineMessages } from 'react-intl-next';
var messages = defineMessages({
  defaultRenderError: {
    id: 'jsm.attachment-field.default-render-error',
    defaultMessage: 'Unable to show attachments in this field. Refresh this page to try again.',
    description: 'Error message when attachment field fails to render'
  },
  attachmentPermissionError: {
    id: 'jsm.attachment-field.attachment-permission-error',
    defaultMessage: 'Contact your admin to grant you permission to attach files.',
    description: 'Error message when user does not have permission to create attachments'
  }
});
export default messages;